// Data structure for "Tham Phải Hiểu" philosophy
export const thamPhaiHieuData = {
  title: "Tham Phải Hiểu - Chọn Đúng Người - Sống Như Ý",
  mainPillars: {
    thamPhaiHieu: {
      title: "1. Tham Phải Hiểu",
      keyPoints: [
        {
          title: "Hiểu chính mình",
          aspects: {
            selfExploration: {
              personalityTraits: [
                "Nỗi sợ cơ bản",
                "Khao khát cơ bản", 
                "Điều coi trọng nhất",
                "Cách giao tiếp với người khác",
                "Phản ứng với căng thẳng",
                "Điều cảm thấy tổn thương nhất",
                "Cách đưa quyết định",
                "Dấu hiệu báo động",
                "Cách phát triển lành mạnh"
              ],
              coreValues: [
                "Giá trị cốt lõi",
                "Thế mạnh, điểm yếu",
                "Kỹ năng chuyên môn",
                "Niềm tin/Đức tin",
                "Thành tựu",
                "Idol/Người ảnh hưởng", 
                "Lĩnh vực yêu thích",
                "Chủ đề quan tâm",
                "Điều muốn làm",
                "Câu nói truyền cảm hứng",
                "Biểu tượng Định vị bản thân"
              ]
            },
            divination: {
              title: "Bói",
              methods: [
                "Quẻ Dịch",
                "Bài Tarot"
              ]
            }
          }
        },
        {
          title: "Hiểu người khác",
          methods: {
            learnable: [
              "Con người tuân theo những mô thức nhất định",
              "Có thể dự đoán được tâm lý và hành vi",
              "Hiểu được suy nghĩ và cảm xúc cải thiện mối quan hệ"
            ],
            approaches: [
              "Tiếp xúc lâu dài và quan sát",
              "Nghiên cứu mạng xã hội",
              "Trò chuyện trực tiếp",
              "Quan sát ngôn ngữ cơ thể",
              "Thu thập thông tin từ người quen",
              "Phân tích cách viết và tương tác",
              "Bài test tính cách",
              "Sinh trắc học",
              "Phân tích theo Tử Vi/Thần số học"
            ]
          },
          humanNature: {
            emotions: "Con người do cảm xúc chứ không phải lý trí định hình lựa chọn",
            inherentNature: "Nhân chi sơ, tính bản thiện - Người sinh ra ban đầu vốn thiện",
            negativeTraits: [
              "Tham (Tham lam)",
              "Sân (Sân hận)", 
              "Si (Si mê, ngu si)",
              "Mạn (Ngạo mạn)",
              "Nghi (Nghi ngờ)"
            ],
            selfishness: {
              types: [
                {
                  name: "Ích kỷ dạt dột",
                  description: "Chỉ nghĩ đến bản thân, không quan tâm người khác"
                },
                {
                  name: "Ích kỷ độc ác",
                  description: "Sẵn sàng làm hại người khác để đạt mục đích"  
                },
                {
                  name: "Ích kỷ khôn ngoan",
                  description: "Làm lợi cho mình bằng cách làm lợi cho người khác"
                }
              ]
            }
          }
        },
        {
          title: "Hiểu thời thế",
          methods: [
            "Theo dõi thời sự",
            "Đọc báo mạng",
            "Tham gia hội nhóm chuyên ngành",
            "Mạng lưới nội bộ",
            "Giao lưu cộng đồng",
            "Nghiên cứu phân tích",
            "Tham khảo chuyên gia"
          ]
        },
        {
          title: "Hiểu quy luật",
          naturalLaws: {
            attraction: {
              title: "Luật Hấp Dẫn",
              principles: [
                "Giống nhau - Hút nhau",
                "Tầng năng lượng nào - Hút tầng năng lượng đó"
              ]
            },
            karmaLaw: {
              title: "Luật Nhân Quả",
              principles: ["Cho - Nhận", "Gieo - Gặt"]
            },
            balance: {
              title: "Luật Cân Bằng",
              principles: [
                "Âm - Dương",
                "Trái - Phải, Trước - Sau",
                "Nặng - Nhẹ, To - Nhỏ",
                "Ác - Thiện"
              ]
            },
            cycle: {
              title: "Luật Luân Hồi",
              principles: [
                "Xuân - Hạ - Thu - Đông",
                "Sáng - Tối",
                "Sinh - Lão - Bệnh - Tử",
                "Thịnh - Suy"
              ]
            },
            impermanence: {
              title: "Luật Vô Thường",
              frameworks: {
                VUCA: [
                  "Biến động - Volatility",
                  "Bất định - Uncertainty",
                  "Phức tạp - Complexity",
                  "Mơ hồ - Ambiguity"
                ],
                TONA: [
                  "Hỗn loạn - Turbulence",
                  "Bất định - Uncertainty",
                  "Khác lạ - Novelty",
                  "Mơ hồ - Ambiguity"
                ]
              }
            }
          }
        }
      ]
    },
    chonDungNguoi: {
      title: "2. Chọn Đúng Người",
      keyChoices: [
        {
          title: "Chọn lẽ sống",
          description: "Quyết định cách sống, giá trị và nguyên tắc sống",
          details: {
            importance: "Đây là lựa chọn quan trọng nhất vì nó quyết định cách sống, giá trị sống và nguyên tắc sống của mỗi người",
            impact: "Chọn lẽ sống đồng nghĩa với việc chọn cuộc đời mình muốn sống và con người mình muốn trở thành",
            control: "Trong cuộc sống có nhiều điều không thể kiểm soát, nhưng điều chắc chắn có thể kiểm soát là chính bản thân mình",
            enlightenment: {
              self: "Để có thể chọn được lẽ sống đúng đắn, con đường duy nhất là tự lực khai phóng",
              others: "Công việc KHÔNG phải để khai sáng người khác, mà là giúp người khác có thêm góc nhìn để họ tự khai sáng"
            },
            independentThinking: {
              essence: "Người có tư duy độc lập luôn nhìn nhận vấn đề một cách chứng kiến, dựa trên nền tảng và hệ quy chiếu của bản thân",
              avoidance: [
                "Tránh tư duy bầy đàn",
                "Tránh tư duy khuôn mẫu",
                "Tránh tư duy ỷ lại"
              ],
              development: [
                "Liên tục học hỏi, mở rộng tư duy",
                "Rèn luyện khả năng phản biện",
                "Tự tin vào chính mình",
                "Cân bằng giữa lý trí và cảm xúc"
              ]
            }
          }
        },
        {
          title: "Chọn người để lấy",
          description: "Xây dựng gia đình mong muốn",
          importance: "Ảnh hưởng lớn đến hạnh phúc cá nhân"
        },
        {
          title: "Chọn việc để làm",
          description: "Định hướng sự nghiệp và tương lai",
          importance: "Công việc có ảnh hưởng rất lớn đến cuộc sống, định hình con người và tương lai phía trước"
        },
        {
          title: "Chọn thầy để học",
          description: "Phát triển tâm và tuệ",
          importance: "Đây chính là chọn tâm và tuệ, chọn đầu và tim của chính mình"
        },
        {
          title: "Chọn bạn để chơi",
          description: "Xây dựng môi trường sống tích cực",
          importance: "Bạn bè ảnh hưởng rất lớn đến suy nghĩ và hành động của mỗi cá nhân"
        }
      ]
    },
    songNhuY: {
      title: "3. Sống Như Ý",
      principles: ["Độc Lập", "Tự Do", "Hạnh Phúc"]
    },
    gioiDinhTue: {
      title: "4. Giới-Định-Tuệ làm Gốc",
      elements: {
        gioi: {
          title: "Giới",
          description: "Nền tảng đạo đức, tuân thủ Ngũ giới",
          principles: [
            "Không sát sinh",
            "Không lấy của người khác",
            "Không tà dâm", 
            "Không nói dối",
            "Không rượu bia, chất kích thích"
          ]
        },
        dinh: {
          title: "Định",
          description: "Tập trung tâm ý, an trú tâm vào một đối tượng duy nhất",
          benefits: "Đạt được trạng thái tâm an tịnh, tĩnh lặng và sáng suốt"
        },
        tue: {
          title: "Tuệ",
          description: "Trí tuệ, sự thấu hiểu sâu sắc về bản chất thực sự của mọi sự vật hiện tượng",
          relationship: [
            "Giới tạo nền tảng cho Định phát triển",
            "Định lắng dịu tâm, là điều kiện để Tuệ sinh khởi",
            "Tuệ lại dẫn dắt và củng cố Giới hạnh"
          ]
        }
      }
    }
  }
};

// Helper function to get relevant philosophy content based on context
export const getPhilosophyContent = (context) => {
  // This function can be expanded to return specific content based on the context
  return thamPhaiHieuData;
};